import axios from 'axios';
import cookieManager from './cookieManager';
import { APP_URL } from '../env';

export function imageUrl(url) {
  return `${APP_URL}/image${url}`
}

/**
 * A card's picture: the small copy (a 300px one the server keeps, /image/small/...) unless `full`, for a card shown
 * full size. Face down it's the card back, a single picture.
 */
export function cardImageUrl(card = null, { full = false } = {}) {
  if (!card || !card.get('image')) {
    return imageUrl('/pokemon-card.jpg');
  }
  return smallUnlessFull(card.get('image'), full);
}

/**
 * A theme deck's box picture (`side` 'image' for the front, 'image_back' for the back): the small copy unless `full`,
 * like cardImageUrl. Null when there's no picture of that side.
 */
export function deckBoxUrl(deck, side = 'image', { full = false } = {}) {
  return deck.get(side) ? smallUnlessFull(deck.get(side), full) : null;
}

const smallUnlessFull = (path, full) => imageUrl(full ? path : `/small${path}`);

export function setAxiosAccessToken() {
  axios.defaults.headers.common['Authorization'] = `Bearer ${cookieManager.getAccessToken()}`;
}

export function normalize(entity) {
  if (entity && typeof entity === 'object') {
    if (entity.data) {
      entity = normalize(entity.data);
    }

    for (const value in entity) {
      if (entity.hasOwnProperty(value)) {
        entity[value] = normalize(entity[value]);
      }
    }

    return entity;
  }

  if (Array.isArray(entity)) {
    return entity.map(normalize);
  }

  return entity;
}
